'use client';

import { createHash } from 'crypto';
import Script from 'next/script';
import React from 'react';

export type CriteoHomepageTagProps = {
  email: string;
};

export function CriteoHomepageTag({ email }: CriteoHomepageTagProps) {
  const shaHashedEmail = createHash('sha256').update(email).digest('hex');
  const md5HashedEmail = createHash('md5').update(email).digest('hex');

  const scriptContents = `window.criteo_q = window.criteo_q || []; var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d"; window.criteo_q.push({ event: "setAccount", account: [24273, 127863] }, { event: "setEmail", email: "${shaHashedEmail}", hash_method: "sha256" }, { event: "setEmail", email: "${md5HashedEmail}", hash_method: "md5" }, { event: "setSiteType", type: deviceType }, { event: "viewHome" });`;

  return (
    <>
      <Script
        id="criteo-homepage-script"
        strategy="lazyOnload"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: scriptContents,
        }}
      />
    </>
  );
}
